import request from '../request'

export default {
  getClasesRecurso: () => {
    return request.get('recurso_clase')
  }
}
